import { render, staticRenderFns } from "./CoursewareChartBlock.vue?vue&type=template&id=14806e39&"
import script from "./CoursewareChartBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareChartBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports